<script setup lang="ts">
import { useHelpers } from '@/shared/lib'
import { VIcons } from '@/shared/ui'

const value = defineModel()
const { generateKey } = useHelpers()

const generate = () => {
  value.value = generateKey()
}
</script>

<template>
  <VTextField v-model="value">
    <template #append-inner>
      <VIcons type="refresh" @click="generate" />
    </template>
  </VTextField>
</template>
